import { isWithinInterval, subYears } from "date-fns";

import UserDetails, { Address } from "../class/userDetails";
import validateEmail from "./validateEmail";
import formatPhoneNumber from "./formatPhoneNumber";

const confirmTransferDetailsValidation = {
  firstName: (userDetails: UserDetails) => {
    if (!userDetails.firstName) {
      return "Please enter your first name";
    } else {
      return "";
    }
  },
  lastName: (userDetails: UserDetails) => {
    if (!userDetails.lastName) {
      return "Please enter your last name";
    }
    return "";
  },
  dateOfBirth: (userDetails: UserDetails) => {
    if (!userDetails.dateOfBirth) {
      return "Please enter your date of birth";
    } else {
      // check interval
      const isBetween = isWithinInterval(userDetails.dateOfBirth, {
        start: new Date("1920-01-01"),
        end: subYears(new Date(), 18),
      });
      if (!isBetween) {
        return "Please enter a valid date of birth";
      } else {
        return "";
      }
    }
  },
  ssnOrTin: (userDetails: UserDetails) => {
    if (!userDetails.ssnOrTin || userDetails.ssnOrTin.length === 0) {
      return "Please enter your social security number or tax identification number.";
    } else if (userDetails.ssnOrTin.length !== 9 || !/^\d+$/.test(userDetails.ssnOrTin)) {
      return "Please enter your valid nine-digit social security number or tax identification number.";
    }
    return "";
  },
  citizenship: (userDetails: UserDetails) => {
    if (!userDetails.citizenship || userDetails.citizenship.length === 0) {
      return "Please select your country of citizenship";
    }
    return "";
  },
  martialStatus: (userDetails: UserDetails) => {
    if (!userDetails.maritalStatus || userDetails.maritalStatus.length === 0) {
      return "Please select your martial status";
    }
    return "";
  },
  spouseName: (userDetails: UserDetails) => {
    if (!userDetails.spouseName || userDetails.spouseName.length === 0) {
      return "Please enter your spouse name";
    }
    return "";
  },
  spouseEmail: (userDetails: UserDetails) => {
    if (!userDetails.spouseEmail || userDetails.spouseEmail.length === 0) {
      return "Please enter your spouse email";
    } else if (!validateEmail(userDetails.spouseEmail)) {
      return "Please enter a valid email";
    }
    return "";
  },
  spousePhoneNumber: (userDetails: UserDetails) => {
    // Format phone number
    if (!userDetails.spousePhoneNumber || userDetails.spousePhoneNumber.length === 0) {
      return "Please enter your spouse phone number";
    }

    const formatedPhoneNumber = formatPhoneNumber(userDetails.spousePhoneNumber);
    if (formatedPhoneNumber.length < 10) {
      return "Please enter valid phone number";
    }
    return "";
  },

  spouseDateOfBirth: (userDetails: UserDetails) => {
    if (!userDetails.spouseDateOfBirth) {
      return "Please enter your spouse's date of birth";
    } else {
      // check interval
      const isBetween = isWithinInterval(userDetails.spouseDateOfBirth, {
        start: new Date("1920-01-01"),
        end: subYears(new Date(), 18),
      });
      if (!isBetween) {
        return "Please enter a valid date of birth";
      } else {
        return "";
      }
    }
  },
  addressLine1: (userDetails: UserDetails) => {
    if (!userDetails.address.addressLine1) {
      return "Please enter your address";
    }
    return "";
  },
  city: (userDetails: UserDetails) => {
    if (!userDetails.address.city) {
      return "Please enter city";
    }
    return "";
  },
  state: (userDetails: UserDetails) => {
    if (!userDetails.address.state) {
      return "Please enter state";
    }
    return "";
  },
  zipCode: (userDetails: UserDetails) => {
    if (!userDetails.address.zipCode) {
      return "Please enter zip code";
    }
    if (userDetails.address.zipCode.length !== 5 || !/^\d+$/.test(userDetails.address.zipCode)) {
      return "Please enter valid zip code";
    }
    return "";
  },
  validateField: (key: keyof UserDetails | keyof Address, userDetails: UserDetails) => {
    switch (key) {
      case "firstName":
        return confirmTransferDetailsValidation.firstName(userDetails);
      case "lastName":
        return confirmTransferDetailsValidation.lastName(userDetails);
      case "dateOfBirth":
        return confirmTransferDetailsValidation.dateOfBirth(userDetails);
      case "ssnOrTin":
        return confirmTransferDetailsValidation.ssnOrTin(userDetails);
      case "citizenship":
        return confirmTransferDetailsValidation.citizenship(userDetails);
      case "maritalStatus":
        return confirmTransferDetailsValidation.martialStatus(userDetails);
      case "spouseName":
        return confirmTransferDetailsValidation.spouseName(userDetails);
      case "spouseEmail":
        return confirmTransferDetailsValidation.spouseEmail(userDetails);
      case "spousePhoneNumber":
        return confirmTransferDetailsValidation.spousePhoneNumber(userDetails);
      case "spouseDateOfBirth":
        return confirmTransferDetailsValidation.spouseDateOfBirth(userDetails);
      case "addressLine1":
        return confirmTransferDetailsValidation.addressLine1(userDetails);
      case "city":
        return confirmTransferDetailsValidation.city(userDetails);
      case "state":
        return confirmTransferDetailsValidation.state(userDetails);
      case "zipCode":
        return confirmTransferDetailsValidation.zipCode(userDetails);

      default:
        return "";
    }
  },
  validatePersonalDetails: (userDetails: UserDetails) => {
    return {
      allPassed:
        confirmTransferDetailsValidation.firstName(userDetails) === "" &&
        confirmTransferDetailsValidation.lastName(userDetails) === "" &&
        confirmTransferDetailsValidation.dateOfBirth(userDetails) === "" &&
        confirmTransferDetailsValidation.citizenship(userDetails) === "" &&
        confirmTransferDetailsValidation.ssnOrTin(userDetails) === "" &&
        confirmTransferDetailsValidation.martialStatus(userDetails) === "",
    };
  },
  validateSpouseInfo: (userDetails: UserDetails) => {
    return {
      allPassed:
        confirmTransferDetailsValidation.spouseName(userDetails) === "" &&
        confirmTransferDetailsValidation.spouseEmail(userDetails) === "" &&
        confirmTransferDetailsValidation.spousePhoneNumber(userDetails) === "" &&
        confirmTransferDetailsValidation.spouseDateOfBirth(userDetails) === "",
    };
  },
  validateMailingAddress: (userDetails: UserDetails) => {
    return {
      allPassed:
        confirmTransferDetailsValidation.addressLine1(userDetails) === "" &&
        confirmTransferDetailsValidation.city(userDetails) === "" &&
        confirmTransferDetailsValidation.state(userDetails) === "" &&
        confirmTransferDetailsValidation.zipCode(userDetails) === "",
    };
  },
};

export default confirmTransferDetailsValidation;
